/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenameProcedureDto
 */
export interface RenameProcedureDto {
    /**
     * New custom name for the procedure
     * @type {string}
     * @memberof RenameProcedureDto
     */
    customName: string;
}

/**
 * Check if a given object implements the RenameProcedureDto interface.
 */
export function instanceOfRenameProcedureDto(value: object): value is RenameProcedureDto {
    if (!('customName' in value) || value['customName'] === undefined) return false;
    return true;
}

export function RenameProcedureDtoFromJSON(json: any): RenameProcedureDto {
    return RenameProcedureDtoFromJSONTyped(json, false);
}

export function RenameProcedureDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameProcedureDto {
    if (json == null) {
        return json;
    }
    return {
        
        'customName': json['customName'],
    };
}

export function RenameProcedureDtoToJSON(json: any): RenameProcedureDto {
    return RenameProcedureDtoToJSONTyped(json, false);
}

export function RenameProcedureDtoToJSONTyped(value?: RenameProcedureDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customName': value['customName'],
    };
}

